var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntertainment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 9.83334V22.5833C23.25 22.9812 23.092 23.3627 22.8107 23.644C22.5294 23.9253 22.1478 24.0833 21.75 24.0833H2.25C1.85218 24.0833 1.47064 23.9253 1.18934 23.644C0.908035 23.3627 0.75 22.9812 0.75 22.5833V9.83334",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 6.83334H0.75V3.08334C0.75 2.68552 0.908035 2.30399 1.18934 2.02268C1.47064 1.74138 1.85218 1.58334 2.25 1.58334H21.75C22.1478 1.58334 22.5294 1.74138 22.8107 2.02268C23.092 2.30399 23.25 2.68552 23.25 3.08334V6.83334Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.83334L9 1.58334",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6.83334L16.5 1.58334",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.488 19.4933C9.3575 19.5584 9.21253 19.5891 9.06685 19.5824C8.92117 19.5757 8.77961 19.532 8.6556 19.4552C8.53159 19.3785 8.42924 19.2714 8.35825 19.144C8.28727 19.0166 8.25001 18.8732 8.25 18.7273V12.9393C8.25001 12.7935 8.28727 12.6501 8.35825 12.5227C8.42924 12.3953 8.53159 12.2882 8.6556 12.2114C8.77961 12.1347 8.92117 12.0909 9.06685 12.0843C9.21253 12.0776 9.3575 12.1083 9.488 12.1733L15.277 15.0683C15.4192 15.1393 15.5387 15.2485 15.6223 15.3836C15.7059 15.5187 15.7502 15.6745 15.7502 15.8333C15.7502 15.9922 15.7059 16.148 15.6223 16.2831C15.5387 16.4182 15.4192 16.5274 15.277 16.5983L9.488 19.4933Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    transform: "translate(0 0.833344)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/entertainment.8d8dd41a.svg";
export { ForwardRef as ReactComponent };